import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import authRequets from "../../../components/api/authRequests";
import userRequests from "../../../components/api/userRequests";
import FooterGoogle from "../../../components/Common/FooterGoogle";
import FormTitle from "../../../components/Common/FormTitle";
import Input from "../../../components/Common/Input/Input";
import PasswordInput from "../../../components/Common/PasswordInput/PasswordInput";
import SignButton from "../../../components/Common/SignButton/SignButton";
import SubTitleLogin from "../../../components/Common/SubTitleLogin";
import dataContext from "../../../context/dataContext";
import SelectInput from "../../../components/Common/SelectInput/SelectInput";
import { validate } from "../Signup/validate";

import styles from "./style.module.css";
import mainContext from "../../../context/mainContext";

export default function InputClassroomId() {
  const [valid, setValid] = useState([]);
  const [level, setLevel] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  let { nav, header, loader: { loaderFetch, setLoaderFetch } } = useContext(mainContext);

  let levelOptions = [7, 10];
  useEffect(() => {
    header.setIsShowHeader(false);
  }, []);

  const { userDetails, setUserDetails } = useContext(dataContext);
  const getDatafromForm = (formData) => ({
    classId: formData.get("classId"),
    level: level,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const body = getDatafromForm(new FormData(e.currentTarget));
    const checkResult = validate(body);
    setValid(checkResult);
    if (checkResult.length) return;
    try {
      setLoaderFetch(true);
      let newUserDetails = await userRequests.updateUserClassId(body, userDetails.id)
      setUserDetails(newUserDetails);
      navigate("/", { replace: true, state: { ...newUserDetails } });
      header.setIsShowHeader(true);


    } catch (err) {
      setError(err.message);
      console.log(err);
    } finally {
      setLoaderFetch(false);
    }
  };

  return (
    <form className={styles.signin} onSubmit={handleSubmit}>
      <FormTitle
        content={`Welcome ${userDetails?.firstName || "First Name is missing!"
          }`}
      />
      <SubTitleLogin content="Enter the classroom id and select the level" />
      <Input
        legend="Classroom id"
        content="Classroom id"
        name="classId"
        valid={!valid.includes("classId")}
      />
      <SelectInput
        legend="Reading Level"
        content="Reading Level"
        placeholder="Select the reading level"
        type="level"
        name="level"
        options={levelOptions}
        onChange={(e) => {
          setLevel(e.target.value);
        }}
        valid={!valid.includes("level")}
      />
      {error && (
        <SubTitleLogin
          content={error}
          color="red"
        //  link="login"
        //  sign="In"
        />
      )}
      <div className={styles.btnHolder}>
        <SignButton content="Register for a class" type="submit" style={{ textTransform: "none" }} />
      </div>
    </form>
  );
}
